<template>
    <div class="knowledge_base_type">
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <div class="demo-split" :style="typeHeight">
          <div class="demo-split-pane" style="float:left;border-right:1px solid #eeeeee;width:30%">
            <div class="panel-header">
              <!-- <div class="panel-title" style="font-weight:bold">知识分类</div> -->
              <Select v-model="selectlib"   placeholder="快捷库类型" style="width:90%"  @on-change="onChangeSort">
                              <Option v-for="(option, index) in LibCategory"  :value="option.id" :key="index">{{option.name}}</Option>
              </Select>
              <div class="panel-tool" title="快捷库编辑" style="margin-top:5px">
                <a style="width: 20px;height: 20px;font-size:20px;" href="javascript:void(0)" @click="setsortType">
                  <span class="el-icon-edit" ></span>
                </a>
              </div>
            </div>
            <div class="ztree" id="sortTreeMenu"></div>
          </div>
          <div class="demo-split-pane" style="float:right;width:70%">
            <div class="fixed_table">
              <div class="fixed_search">
                <div class="fixed_search_input">
                  <Input v-model="fastwords" placeholder="快捷词" title="快捷词" clearable/>
                </div>
                <div class="fixed_search_input">
                  <Input v-model="fastcontent" placeholder="话术内容" title="快捷内容" clearable/>
                </div>
                <!-- <div class="fixed_search_input" v-if="selectlib=='1'">
                  <Input v-model="creator" placeholder="创建者" title="创建者" clearable/>
                </div> -->
                <div class="fixed_operation_btn">
                  <Button type="primary"  @click="searchfast">查询</Button>
                  <Button class="search_btn" type="success" :disabled="selectedTreeName == '根目录'" style="margin-left: 10px;" v-if="roleList['3_12-4-4']" @click="addspeechcraft()">添加</Button>
                </div>
              </div>
              <div class="table_head">
                <table>
                  <tr>
                    <th class="font_style_set" style="width:40%;">快捷词</th>
                    <th class="font_style_set" style="width:40%;">话术内容</th>
                    <th class="font_style_set" style="width:20%;border-right: 0px">操作</th>
                  </tr>
                </table>
              </div>
              <div style="border-bottom: 1px solid rgb(235, 238, 245);" class="footer_style" :style="tableHeight">
                <table class="table_head_footer">
                  <tr v-for="(item , index) in contentList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
                    <td style="width:40%;" :title="item.replyWord">{{item.replyWord}}</td>
                    <td style="width:40%;" :title="item.replyContent">{{item.replyContent}}</td>
                    <td class="template_table_btn" style="width:20%;">
                      <span class="search_btn" @click="editspeechcraft(item.id+'',item.replyId+'')" v-if="roleList['3_12-4-5']">编辑</span>
                      <span class="search_btn" @click="deletspeechcraft(item.id+'')" v-if="roleList['3_12-4-6']">删除</span>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="page_style">
                  <Page :total="total" size="small"  :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
                <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
              </div>
            </div>
          </div>
      </div>
      <shortcutCategoryPop :showLibraryEdit="showLibraryEdit"  @closeLibraryEdit="closeLibraryEdit" :sorttitle="sorttitle" :selectlib="selectlib"></shortcutCategoryPop>
      <addspcraPop :showaddspcra="showaddspcra" @closeaddspcra="closeaddspcra" :sortId="sortId" :sorttitle="sorttitle"  :selectlib="selectlib" :selectedTreeId="selectedTreeId" :reId="reId"></addspcraPop>
    </div>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    import shortcutCategoryPop from '@/components/systemSetup/DialogueConfigure/shortcutCategoryPop.vue'
    import addspcraPop from '@/components/systemSetup/DialogueConfigure/addspcraPop.vue'
    export default {
        name: "ReplyMenu",
        mixins:[publicFunClass],
        components:{
         shortcutCategoryPop,
         addspcraPop
        },
        props:{
          pageCode:String
        },
        data(){
          return {
            showPageCount:0,

            splitreply: 0.3,

            spinShow: false,
            roleList:JSON.parse(localStorage.getItem("roleList")),
            pageSizeList:[10,20,30,40,50,100,200],
            speedChangePage: 1,
            currentPage:1,
            pageSize:20,
            total:0,
            typeHeight:{height:''},
            tableHeight:{height:''},
            checkedAll:false,
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
            agentInfo: JSON.parse(localStorage.getItem("agentInfo")),
            fastwords:'',
            fastcontent:'',
            creator:'',
            selectlib:'1',
            LibCategory:[{'id':'1','name':'个人库'},{'id':'0','name':'公共库'}],
            contentList:[],
            selectedTreeId:'',
            inspectTreeData:[],
            showLibraryEdit:false,
            sorttitle:'',
            showaddspcra:false,
            sortId:'',
            selectedsubId:'',
            selectedTreeName:'根目录',
            reId:'',
          }
        },
        methods:{
          //选择库改变
          onChangeSort:function(e){
              this.contentList=[];
              this.selectedTreeName = '根目录';
              this.initsearchlibrary();
          },
          initSortmenuTree:function () {//树初始化
              let that=this;
              let setting = {
                view: {
                  dblClickExpand: false,
                  showLine: true,
                  selectedMulti: false
                },
                data: {
                  simpleData: {
                    enable:true,
                    idKey: "id",
                    pIdKey: "pid",
                    rootPId: ""
                  },
                  key:{
                    name:"replyClassName"
                  }
                },
                callback: {
                  onClick: zTreeOnClick,//单击事件
                }
              };
              function zTreeOnClick(event,treeId,treeNode) {
                that.selectedTreeName = treeNode.replyClassName;
                that.selectedTreeId=treeNode.id;
                that.selectedsubId=treeNode.subId;
                that.initSearch(treeNode.subId);
              }
              let zNodes =this.inspectTreeData;
              if (zNodes){
                $(document).ready(function(){
                  let zTree=$.fn.zTree.init($("#sortTreeMenu"), setting, zNodes);//t:用于展现 zTree 的 DOM 容器,setting:zTree 的配置数据,zNodes:zTree 的节点数据
                  zTree.expandAll(true);
                  let nodes = zTree.getNodes();
                  if (nodes.length > 0) {
                    zTree.selectNode(nodes[0]);//默认选中根节点
                  }
                });
              }
          },
          initsearchlibrary:function () {//查询左侧树(开始一进来为个人类)
              let param={
                replyType:this.selectlib,
                agentNumber:this.agentInfo.agentNumber,
                meanType:'1'
              };
              let that=this;
              this.$http.post("chatReply/toSelectChatReplyDetail.json",param) .then(function (res) {
                let result=res.data.flag;
                if(result!="666"){
                  that.$Modal.info({
                    title:'提示',
                    content:res.data.msg
                  });
                  return false;
                }
                let list=res.data.obj.list;
                let agentNumber = that.agentInfo.agentNumber;
                if('0' == that.selectlib){
                  agentNumber = '';
                }
                let paramTwo={
                  agentNumber:agentNumber,
                  id:'0',
                  pid:'null',
                  replyClassName:'根目录',
                  replyType:that.selectlib
                };
                list.push(paramTwo);
                that.inspectTreeData =list;
                for (let i=0;i<list.length;i++){
                  let pid=list[i].pid;
                  if(pid=="0"){
                    that.selectedTreeId=list[i].id;
                   // that.initSearch(list[i].id);
                  }
                }
                that.initSortmenuTree();
              });
          },
          initSearch:function (ids) {//查询话术内容
              if(!ids){
                ids="";
              }
              let param={
                subId:ids,
                pageNum:this.currentPage,
                pageSize:this.pageSize,
                replyType:this.selectlib,
                meanType:'1'
              };
              this.speedChangePage=this.currentPage;
              let that=this;
              this.$http.post("chatReply/toSelectReplyRelationInfo.json",param) .then(function (res) {
                let result=res.data.flag;
                if(result!="666"){
                  that.$Modal.info({
                    title:'提示',
                    content:res.data.msg
                  });
                  return false;
                }
                that.contentList=res.data.obj.list.content;;
                that.total=res.data.obj.list.totalSize;
              });
          },
          searchfast:function(){
                // if(!this.fastwords){
                //   this.$Modal.info({
                //     title:'提示',
                //     content:"快捷词不能为空"
                //   });
                //   return false;
                // }
                let param={
                  subId:this.selectedsubId,
                  replyWord:this.fastwords,
                  replyContent:this.fastcontent,
                  replyType:this.selectlib,
                  meanType:'1'
                };
                let that=this;
                this.$http.post("chatReply/toSelectReplyRelationInfo.json",param) .then(function (res) {
                  let result=res.data.flag;
                  if(result!="666"){
                    that.$Modal.info({
                      title:'提示',
                      content:res.data.msg
                    });
                    return false;
                  }
                  that.contentList=res.data.obj.list.content;;
                });
          },
          setsortType:function(){//打开操作类目页面
            this.showLibraryEdit=true;
            if(this.selectlib=='1'){
                this.sorttitle="个人库分类";
            }else if(this.selectlib=='0'){
                this.sorttitle="公共库分类";
            }
          },
          //关闭操作类目
          closeLibraryEdit:function(flag){
            this.showLibraryEdit=false;
            if(flag){
              this.initsearchlibrary();
            }
          },
          //关闭话术内容
          closeaddspcra:function(flag){
              this.showaddspcra=false;
              if(flag){
                this.initSearch(this.selectedsubId);
              }
          },
          addspeechcraft:function(){
            this.showaddspcra=true;
            this.sorttitle="添加话术";
            this.sortId="";
          },
          editspeechcraft:function(ids,reids){
            this.showaddspcra=true;
            this.sorttitle="编辑话术";
            this.sortId=ids;
            this.reId=reids;
          },
          deletspeechcraft:function(ids){
            let param={
                id:ids,
                replyType:this.selectlib,
                meanType:'1',
                journalType:"系统管理=>会话配置=>快捷回复=>删除话术",
                menuId:"3_12-4-6"
              };
            let that=this;
            this.$Modal.confirm({
              title: '提示',
              content:'是否确定删除',
              onOk:()=>{
                that.$http.post('chatReply/doDeleteRelation.json',param).then(res=>{
                      let response = res.data
                      if (response.flag !== '666') {
                        that.$alert(response.msg,'提示',{
                          confirmButtonText:'确定'
                        })
                        return false
                      }
                      that.$Message.info('删除成功');
                      this.initSearch(this.selectedsubId);
                })
              }
            })
          },
          //设备信息当前页改变
          changeCurrent(event) {
            this.currentPage=event;
            this.initSearch(this.selectedsubId);
          },
          //设备信息页面显示数量改变
          changeSize(event) {
            this.currentPage=1;
            this.pageSize=event;
            this.initSearch(this.selectedsubId);
          },


        },
        created(){
          this.typeHeight.height=this.mountHeight(92);
          this.tableHeight.height=this.mountHeight(230);
          this.contentList=[];
          this.initsearchlibrary();
        },
        watch:{
          // pageCode:function () {
            // if(this.pageCode=='3_12-4' && this.showPageCount==0){
              // this.showPageCount++;
              // this.contentList=[];
            // }
          // },
        }
    }
</script>

<style scoped>
  .demo-split{
    border: 1px solid #dcdee2;
  }
  .demo-split-pane{
    padding: 10px;
  }
  .currentKnowId{
    background-color: #57a3f3 !important;
    color: #fbfbfc !important;
  }



</style>



// WEBPACK FOOTER //
// src/components/systemSetup/DialogueConfigure/ReplyMenu.vue